import React, { useState } from "react";
import { toast } from "sonner";
import { useT } from "@/lib/LanguageContext";
import { crmErrorMessage } from "../api/crmErrors";
import CrmAlertDialog from "../ui/CrmAlertDialog";
import { CRM } from "../../../constants/testIds/crm";

/**
 * "Archive" (design §E.8): a confirmation, not a silent row action — an archived pack
 * can no longer be assigned, though balances already on a client are untouched. Owner
 * only (`managePacks`); the caller hides the trigger for a Helper.
 */
export default function ArchivePackDialog({ pack, onClose, onArchived }) {
  const t = useT("crm");
  const tc = useT("common");
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      await onArchived(pack);
      toast.success(t("packs.archived"));
      onClose();
    } catch (e) {
      toast.error(crmErrorMessage(e, t, tc));
    } finally {
      setBusy(false);
    }
  };

  return (
    <CrmAlertDialog
      open
      onOpenChange={(o) => { if (!o) onClose(); }}
      title={t("packs.archiveTitle")}
      description={t("packs.archiveBody", { name: pack.name })}
      confirmLabel={t("packs.archive")}
      tone="danger"
      busy={busy}
      onConfirm={confirm}
      testId={CRM.packsArchiveDialog}
      confirmTestId={CRM.packsArchiveConfirm}
    />
  );
}
